import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import USER_LOGIN_QUERY from '@challenger/care/services/queries/login';
import { map } from 'rxjs/operators';
import { CmsJsonService } from '@challenger/care/modules/cms-json/services/cms-json.service';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class LoginService {
  constructor(private apollo: Apollo, private cmsJsonService: CmsJsonService) {}

  getLoginContent(useLocalJson: boolean = false): Observable<any> {
    // TODO - temp solution to use content instead of strapi
    return useLocalJson
      ? this.cmsJsonService.getUserLogin()
      : this.apollo
          .watchQuery({ query: USER_LOGIN_QUERY })
          .valueChanges.pipe(map((result: any) => result?.data?.userLogin));
  }
}
